// otLabel — helper used everywhere we render an OT identifier in the UI.
//
// Operators told us they want to see the free-form name/reference they
// typed when creating the OT (customRef) instead of the auto-generated
// `OT-YYYY-NNNN`. Using this helper keeps the substitution consistent
// across screens (list, expand panel, live panel, monitor, gantt, mobile
// driver app, toasts).
//
// Rules:
//   • If `customRef` exists and is non-empty, return it.
//   • Else fall back to `orderNumber`.
//   • Else (legacy / partial records) return `OT-<id>`.
//   • Returns `—` for null/undefined input so callers can render safely.
//
// `otTooltip` returns both pieces joined when both exist — useful in
// hover titles so the operator can still see the official OT-YYYY-NNNN
// even when the visible label is the custom one.

export function otLabel(o) {
  if (!o) return '—';
  if (typeof o === 'string') return o;
  const ref = (o.customRef || '').trim();
  if (ref) return ref;
  return o.orderNumber || (o.id ? `OT-${o.id}` : '—');
}

export function otTooltip(o) {
  if (!o) return '';
  const ref = (o.customRef || '').trim();
  const num = o.orderNumber || (o.id ? `OT-${o.id}` : '');
  if (ref && num && ref !== num) return `${ref} · ${num}`;
  return ref || num || '';
}
